<template>
  <div class="legal-container">
    <div class="legal-content">
      <h1>使用条款</h1>
      <p class="last-updated">最后更新时间：2025年1月</p>

      <section>
        <h2>1. 接受条款</h2>
        <p>
          欢迎访问 Xster 创意空间（"本网站"、"我们"或"我们的"）。通过访问和使用本网站，您同意遵守并受以下使用条款（"条款"）的约束。如果您不同意这些条款，请不要使用本网站。
        </p>
      </section>

      <section>
        <h2>2. 网站使用</h2>
        <h3>2.1 许可</h3>
        <p>我们授予您有限的、非独占的、不可转让的许可，仅供个人和非商业目的访问和使用本网站。</p>

        <h3>2.2 禁止行为</h3>
        <p>您同意不会：</p>
        <ul>
          <li>以任何违反适用法律法规的方式使用本网站</li>
          <li>尝试未经授权访问本网站的任何部分或系统</li>
          <li>使用任何自动工具（如机器人、爬虫）访问本网站</li>
          <li>干扰或破坏本网站的安全性</li>
          <li>复制、修改、分发或创建本网站内容的衍生作品（除非明确允许）</li>
          <li>使用本网站传输任何恶意软件、病毒或其他有害代码</li>
        </ul>
      </section>

      <section>
        <h2>3. 知识产权</h2>
        <p>
          本网站及其所有内容，包括但不限于文本、图形、徽标、图标、图像、音频剪辑、数字下载和软件，均为 Xster 或其内容提供商的财产，受版权、商标和其他知识产权法保护。
        </p>
        <p>
          未经我们明确书面许可，您不得复制、修改、分发、显示、执行或创作本网站任何内容的衍生作品。
        </p>
      </section>

      <section>
        <h2>4. 用户生成的内容</h2>
        <p>
          如果您在本网站上提交、发布或传输任何内容（包括但不限于评论、反馈或建议），您授予我们非独占、免版税、永久的、不可撤销的权利，可以在全球范围内使用、复制、修改、改编、发布、翻译和分发这些内容。
        </p>
        <p>您声明并保证您拥有提交内容的权利，且内容不违反任何第三方的权利。</p>
      </section>

      <section>
        <h2>5. 免责声明</h2>
        <p>
          <strong>本网站按"现状"提供，不提供任何明示或暗示的保证。</strong>我们不对以下内容做出保证：
        </p>
        <ul>
          <li>本网站将满足您的要求</li>
          <li>本网站将不间断、及时、安全或无错误</li>
          <li>通过本网站获得的结果将准确或可靠</li>
          <li>本网站上的任何缺陷将被纠正</li>
        </ul>
        <p>
          本网站可能包含技术错误或排版错误。我们保留随时对本网站进行更改的权利，恕不另行通知。
        </p>
      </section>

      <section>
        <h2>6. 责任限制</h2>
        <p>
          在法律允许的最大范围内，Xster 及其关联公司、员工、代理和许可方不对因使用或无法使用本网站而产生的任何直接、间接、偶然、特殊、后果性或惩罚性损害承担责任，包括但不限于利润损失、数据丢失或业务中断。
        </p>
      </section>

      <section>
        <h2>7. 第三方链接</h2>
        <p>
          本网站可能包含指向第三方网站的链接。这些链接仅为了您的方便而提供。我们不对这些外部网站的内容、隐私政策或做法负责，也不认可这些网站。您访问这些网站的风险由您自行承担。
        </p>
      </section>

      <section>
        <h2>8. 广告</h2>
        <p>
          本网站可能包含第三方广告。我们不对这些广告的内容、准确性或可用性负责。您与广告商或第三方之间的任何交易均由您自行承担风险。
        </p>
        <p>
          我们使用 Google AdSense 来展示广告。Google 使用 Cookie 来根据您访问本网站和其他网站的情况向您展示相关广告。您可以通过访问
          <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google广告设置</a>
          来选择退出基于兴趣的广告。
        </p>
      </section>

      <section>
        <h2>9. 隐私</h2>
        <p>
          您的隐私对我们很重要。有关我们如何收集、使用和保护您的个人信息的信息，请参阅我们的
          <router-link to="/privacy">隐私政策</router-link>。
        </p>
      </section>

      <section>
        <h2>10. 终止</h2>
        <p>
          我们保留在任何时候，无论是否有理由，立即终止或暂停您访问本网站的权利，恕不另行通知。如果您违反这些条款，您的访问权限可能会被终止。
        </p>
      </section>

      <section>
        <h2>11. 适用法律</h2>
        <p>
          这些条款应受中华人民共和国法律管辖并按其解释。因本条款引起的或与之相关的任何争议应提交有管辖权的人民法院解决。
        </p>
      </section>

      <section>
        <h2>12. 条款的修改</h2>
        <p>
          我们保留随时修改这些条款的权利。我们将在本页面上发布任何更改，并更新"最后更新时间"。您继续使用本网站即表示您接受修改后的条款。我们建议您定期查看这些条款。
        </p>
      </section>

      <section>
        <h2>13. 可分割性</h2>
        <p>
          如果这些条款的任何条款被认定为无效或不可执行，其余条款仍将完全有效。
        </p>
      </section>

      <section>
        <h2>14. 联系我们</h2>
        <p>
          如果您对这些使用条款有任何问题，请通过以下方式联系我们：
        </p>
        <p>
          邮箱：请联系我们通过网站上的联系页面<br/>
          网站：<router-link to="/contact">联系页面</router-link>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfServicePage",
};
</script>

<style scoped>
.legal-container {
  position: relative;
  background: rgba(0, 68, 170, 0.3);
  overflow-y: auto;
  height: 80vh;
  padding: 20px;
  color: #f7f7f7;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.legal-container::-webkit-scrollbar {
  display: none;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.8;
}

.legal-content h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
  color: #fff;
}

.last-updated {
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
  margin-bottom: 30px;
}

.legal-content section {
  margin-bottom: 30px;
}

.legal-content h2 {
  font-size: 1.5em;
  margin-top: 25px;
  margin-bottom: 15px;
  color: #fff;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 5px;
}

.legal-content h3 {
  font-size: 1.2em;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #fff;
}

.legal-content p {
  margin-bottom: 15px;
  text-align: justify;
}

.legal-content ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.legal-content li {
  margin-bottom: 10px;
}

.legal-content a {
  color: #66b3ff;
  text-decoration: underline;
}

.legal-content a:hover {
  color: #99ccff;
}

@media (max-width: 768px) {
  .legal-content {
    padding: 10px;
  }

  .legal-content h1 {
    font-size: 2em;
  }

  .legal-content h2 {
    font-size: 1.3em;
  }
}
</style>

